import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, ActivatedRoute, Params, Route } from '@angular/router';
import { UserService } from './user.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-user',
  templateUrl: 'user.component.html',
  styleUrls: ['user.component.scss']
})

export class UserComponent implements OnInit {

  public pageTitle: string;
  public pageContent: string;
  public cdn = environment.cdn;
  public role = 'client';
  public path_account_profile = '';
  public path_account_orders = '';
  public path_account_invoices = '';
  public path_account_evidence = '';
  public path_account_discounts = '';
  public path_account_returns = '';
  public path_account_users = '';
  public path_account_files = '';
  public path_account_favorites = '';
  public path_logout = '';
  public path_account_password = '';
  public path_account_bonuses = '';
  public path_account_warranties = '';
  public path_account_contacts = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, private route: ActivatedRoute) {
    // navigationService.currentPage.subscribe(this.pageChanged);
    this.path_logout = this.router.config.find(x => x.data.id === -984).path;
    this.path_account_profile = this.router.config.find(x => x.data.id === -992).path;
    this.path_account_orders = this.router.config.find(x => x.data.id === -993).path;
    this.path_account_returns = this.router.config.find(x => x.data.id === -994).path;
    this.path_account_discounts = this.router.config.find(x => x.data.id === -995).path;
    this.path_account_invoices = this.router.config.find(x => x.data.id === -1002).path;
    this.path_account_evidence = this.router.config.find(x => x.data.id === -1006).path;
    this.path_account_users = this.router.config.find(x => x.data.id === -1003).path;
    this.path_account_files = this.router.config.find(x => x.data.id === -1004).path;
    this.path_account_favorites = this.router.config.find(x => x.data.id === -1005).path;
    this.path_account_password = this.router.config.find(x => x.data.id === -1007).path;
    this.path_account_bonuses = this.router.config.find(x => x.data.id === -1008).path;
    this.path_account_warranties = this.router.config.find(x => x.data.id === -1009).path;
    this.path_account_contacts = this.router.config.find(x => x.data.id === -1011).path;
  }

  ngOnInit() {

    this.pageTitle = this.route.snapshot.data.name;
    this.pageContent = this.route.snapshot.data.content;
    if (isPlatformBrowser(this.platformId)) {
      this.role = localStorage.getItem('user_role');
    }
  }


}
